import { RestApiKey } from 'graphql/generated/graphqlTypes';

export function generateMockRestApiKey({
  apiKey = 'mockRestApiKeyApiKey',
  createdAt = 'mockRestApiKeyCreatedAt',
  description = 'mockRestApiKeyDescription',
  id = 'mockRestApiKeyId',
  tenantId = 'mockRestApiKeyTenantId'
}: Partial<Omit<RestApiKey, '__typename'>>): RestApiKey {
  return {
    __typename: 'RestApiKey',
    apiKey,
    createdAt,
    description,
    id,
    tenantId
  };
}
